module.exports = __webpack_public_path__ + "static/media/error.1d300c4e.jpeg";